document.addEventListener('DOMContentLoaded', function() {
  try {
    umami.track(function(mainProps) {
      const data = { ...mainProps, url: window.location.href, title: document.title }
      return data
    })
  }
  catch(err) { console.log('Umami: error in processing.') }
})
